import { render, staticRenderFns } from "./PDFPreview.vue?vue&type=template&id=61e6fc76&scoped=true&"
import script from "./PDFPreview.vue?vue&type=script&lang=js&"
export * from "./PDFPreview.vue?vue&type=script&lang=js&"
import style0 from "./PDFPreview.vue?vue&type=style&index=0&id=61e6fc76&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61e6fc76",
  null
  
)

export default component.exports